import { getAnalytics } from "@tm/insurance/analytics";
import { TextNodeType } from "@tm/ui-widgets/components";
import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import { useCallback, useRef } from "react";
import FlexComp from "../FlexComp/FlexComp";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import { PoweredByContainer } from "./PoweredBySection.style";

export interface IPoweredBy {
  icon?: string;
  title?: TextNodeType;
  description?: TextNodeType;
  iconsList?: string[];
}

const PoweredBySection = ({ data }: { data: IPoweredBy }) => {
  const { icon, title, description, iconsList } = data;

  const analytics = getAnalytics();
  const hasTracked = useRef<boolean>(false);

  // Track component view when it comes into viewport
  const handleIntersection = useCallback((data: IntersectionObserverData) => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "powered_by_section_seen",
      });
    }
    hasTracked.current = true;
  }, []);

  const { ref: poweredBySectionRef } = useIntersectionObserver(
    handleIntersection,
    {
      threshold: 0.5, // Trigger when 50% of component is visible
      triggerOnLeaveViewport: true,
    }
  );

  return (
    <PoweredByContainer ref={poweredBySectionRef}>
      <FlexComp alignItems="center" gap="4px">
        <FormattedText value={title} />
        {iconsList?.length
          ? iconsList.map((url, index) => (
              <ImageComponent
                key={index}
                src={url}
                height="48px"
                width="auto"
                alt={`powered by icon ${index + 1}`}
              />
            ))
          : icon ? (
              <ImageComponent src={icon} height="48px" width="auto" />
            ) : null}
      </FlexComp>
      <FormattedText value={description} />
    </PoweredByContainer>
  );
};

export default PoweredBySection;
